import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit/typography';
import * as styles from './Phone.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Phone = function Phone(_ref) {
  var phone = _ref.phone;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "Phone",
    className: styles['phone'],
    children: /*#__PURE__*/_jsx(UIHeading4, {
      children: phone
    })
  });
};